










import Vue from 'vue';
import { getAvatarURL } from '@/core/utils/utils';

export default Vue.extend({
  name: 'HMStudentAvatar',
  props: {
    photo: {
      type: String,
      required: false,
    },
    full_name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '25px',
    },
    primaryColor: {
      type: String,
      default: '#000000',
    },
  },
  computed: {
    avatarURL() {
      const color = 'white';
      const background = this.primaryColor;
      const fontSize = '48';
      const size = '120';

      return (
        this.photo ||
        getAvatarURL(this.full_name, background, color, fontSize, size)
      );
    },
  },
});
